import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js"

export default class extends Controller {
  static values = { id: String, url: String }

  connect() {
    this.isLoaded = false
    this.initTippy()
  }

  disconnect() {
    if (this.tippyInstance) {
      this.tippyInstance.destroy()
    }
  }

  initTippy() {
    const controller = this

    this.tippyInstance = tippy(this.element, {
      content: '<div class="h-6 w-6 rounded-full border-4 border-t-4 border-gray-50 border-t-orange-700 animate-spin"></div>',
      allowHTML: true,
      placement: "top",
      delay: [200, 0],

      async onShow(instance) {
        if (controller.isLoaded) return

        const commentId = controller.idValue

        const apiUrl = commentId
          ? `/api/events/${commentId}`
          : `/entries/${controller.extractEntryId()}/tippy`

        try {
          const response = await fetch(apiUrl)

          if (!response.ok) throw new Error("Ошибка сети")

          const data = await response.json()
          let tooltipContent = ""

          if (commentId) {
            tooltipContent = `<strong>${data.author}:</strong> ${data.body}`
          } else {
            tooltipContent = `
              <div class="entry-preview">
                <div class="font-bold text-sm border-b border-slate-200 pb-1 mb-1">${data.title}</div>
                <div class="text-xs space-y-0.5 text-slate-600">
                  <div class="flex items-center gap-x-2"><span class="text-slate-400">Статус:</span><span>${data.status || '—'}</span></div>
                  <div class="flex items-center gap-x-2"><span class="text-slate-400">Исполнитель:</span><strong>${data.assignee || '—'}</strong></div>
                  <div class="flex items-center gap-x-2"><span class="text-slate-400">Крайний срок:</span><span>${data.deadline || '—'}</span></div>
                </div>
              </div>`
           }

          instance.setContent(tooltipContent)
          controller.isLoaded = true
        } catch (error) {
          console.error("Не удалось загрузить данные для:", error)
          instance.setContent("⚠️ Не удалось загрузить данные")
        }
      }
    })
  }

  extractEntryId() {
    if (!this.urlValue) return ''
    const match = this.urlValue.match(/\/entries\/([a-zA-Z0-9_-]+)/)
    return match ? match[1] : ''
  }


  goToComment(event) {
    const targetId = `event_${this.idValue}`
    const targetElement = document.getElementById(targetId)

    if (targetElement) {
      event.preventDefault()
      event.stopPropagation()

      window.location.href = this.urlValue

    } else if (this.urlValue) {
      event.preventDefault()
      event.stopPropagation()

      window.open(this.urlValue, '_blank', 'noopener,noreferrer')
    }
  }


  goToEntry(event) {
    event.stopPropagation()
    event.preventDefault()

    if (this.urlValue) {
      window.open(this.urlValue, '_blank', 'noopener,noreferrer')
    }
  }
}
